import { Inject, Injectable } from '@angular/core';

/**
 * Logging service.
 *
 * It logs to console.log if debug is enabled: debug query parameter is present.
 */
@Injectable()
export class LoggerService {

    constructor(@Inject('debug') private debug: boolean) {}

    /**
     * Logs to console.
     *
     * @param args logged parameters
     */
    public log(...args) {
        if (this.debug) {
            console.log(...['### SSP:', new Date().toISOString(), ...args]);
        }
    }

    /**
     * Warns to console.
     *
     * @param args logged parameters
     */
    public warn(...args) {
        console.warn(...['### SSP:', new Date().toISOString(), ...args]);
    }

    /**
     * Logs errors to console.
     *
     * @param args logged parameters
     */
    public error(...args) {
        console.error(...['### SSP:', new Date().toISOString(), ...args]);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/core/services/logger.service.ts